import { useState } from "react";
import { FilePlus2, Save } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

function fileNameForPath(path: string): string {
  return path.split("\\").pop() ?? path;
}

function parentPathFor(path: string): string {
  const parts = path.split("\\");
  parts.pop();
  return parts.join("\\") || "C:\\Users\\Student\\Desktop";
}

export function NotepadApp({ activeMachine, onRunCommand }: SimulatorAppSurfaceProps) {
  const [path, setPath] = useState("C:\\Users\\Student\\Desktop\\notes.txt");
  const [content, setContent] = useState("Ticket notes\r\n- Investigation started\r\n");

  async function createFile() {
    await onRunCommand({
      appId: "notepad",
      commandType: "FILE_CREATE",
      capability: "file.file.write",
      label: `Create ${fileNameForPath(path)}`,
      payload: {
        content,
        machineId: activeMachine,
        name: fileNameForPath(path),
        parentPath: parentPathFor(path),
        path
      }
    });
  }

  async function saveFile() {
    await onRunCommand({
      appId: "notepad",
      commandType: "FILE_WRITE_CONTENT",
      capability: "file.file.write",
      label: `Save ${fileNameForPath(path)}`,
      payload: { content, machineId: activeMachine, path }
    });
  }

  return (
    <div className="fd-sim-app fd-notepad">
      <div className="fd-sim-app-toolbar">
        <button type="button" onClick={() => void createFile()}><FilePlus2 size={16} /> New file</button>
        <button type="button" onClick={() => void saveFile()}><Save size={16} /> Save</button>
        <label className="fd-notepad-path">
          Path
          <input value={path} onChange={(event) => setPath(event.target.value)} />
        </label>
      </div>
      <textarea
        aria-label="Notepad document"
        spellCheck={false}
        value={content}
        onChange={(event) => setContent(event.target.value)}
      />
    </div>
  );
}
